// 发票管理页面路由
const jksq = () => import('@/views/cwgl/jksq/jksqApply.vue');
const flowApply = () => import('@/views/cwgl/jksq/flow/flow_Apply.vue');
const flowApprove = () => import('@/views/cwgl/jksq/flow/flow_Approve.vue');
const flowFinanceApprove = () => import('@/views/cwgl/jksq/flow/flow_financeApprove.vue');

const jk = () => import('@/views/cwgl/jk.vue');

const jkLedger = () => import('@/views/cwgl/jkLedger.vue');

export default [
  {
    path: '/cwgl/jk/apply',
    name: 'jksq',
    meta: {
      title: '借款申请',
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: jksq
  },
  {
    path: '/cwgl/jk/flow/apply',
    name: 'flowApply',
    meta: {
      title: '借款申请',
      icon: 'dashboard',
      noCache: false,
      affix: false
    },
    component: flowApply
  },

  {
    path: '/cwgl/jk/flow/approve',
    name: 'flowApprove',
    meta: {
      title: '借款审批',
      icon: 'dashboard',
      noCache: false,
      affix: false
    },
    component: flowApprove
  },

  {
    path: '/cwgl/jk/flow/financeApprove',
    name: 'flowFinanceApprove',
    meta: {
      title: '借款财务审批',
      icon: 'dashboard',
      noCache: false,
      affix: false
    },
    component: flowFinanceApprove
  },
  {
    path: '/cwgl/jk',
    name: 'jk',
    meta: {
      title: '借款管理',
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: jk
  },
  {
    path: '/cwgl/jk/Ledger',
    name: 'jkLedger',
    meta: {
      title: '借款台账',
      icon: 'dashboard',
      noCache: false,
      affix: true
    },
    component: jkLedger
  }
];
